export default `
<div ng-click="$ctrl.loadMore()" ng-hide="$ctrl.isLastPage || $ctrl.isLoading">
  <ng-transclude></ng-transclude>
</div>
<ut-loading-dots ng-if="$ctrl.isLoading"></ut-loading-dots>
`;
